export default __webpack_public_path__ + "static/media/icon-pencil-edit-active.3fd32fe1.svg";